import React from 'react';
import classnames from 'classnames';

import Button from './Button';
import Heading from './renderers/Heading';
import MarkdownRenderer from './MarkdownRenderer';
import Testimonial from './Testimonial';

const IndustryCard = (
  {
    id,
    slug,
    title,
    subTitle,
    content,
    featuredContent,
    isFeatured = false,
    linkPath,
    featuredCaseStudies = [],
  },
  index
) => {
  const [caseStudy] = featuredCaseStudies;
  const isEven = index % 2;

  const wrapperClass = classnames(
    '-mx-6 flex items-center flex-col lg:flex-row',
    {
      'lg:flex-row-reverse': isEven || isFeatured,
    }
  );

  return (
    <section key={id} className="md:py-6">
      {!isFeatured && (
        <div className="mb-6 md:mb-12 text-center max-w-2xl lg:max-w-full mx-auto">
          <Heading level={2} id={slug}>
            {title}
          </Heading>
          <hr className="inline-block bg-cornflower border-0 h-1 my-6 rounded w-24 md:w-48" />
        </div>
      )}

      <div className={wrapperClass}>
        {caseStudy && (
          <article className="mb-12 lg:mb-0 w-full max-w-2xl lg:w-1/2 px-6">
            <Testimonial {...caseStudy} />
          </article>
        )}

        <div className="w-full max-w-2xl lg:w-1/2 px-6">
          {!isFeatured && (
            <div className="-mt-12">
              <Heading level={3}>{subTitle}</Heading>
            </div>
          )}
          <MarkdownRenderer
            content={isFeatured && featuredContent ? featuredContent : content}
          />

          <div className="mt-4 lg:mt-6">
            <Button href={linkPath} appearance="outline" colour="pink">
              Learn more &#8594;
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryCard;
